export default __webpack_public_path__ + "static/media/typicons.17be2f81.eot";